import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(cardContainerStyles, {
    cardDivider: {
        css: css`
            width: 100%;
            padding: 20px 0;
            border-top: 1px solid ${getColor("common.border")};
            &:last-child {
                border-bottom: 1px solid ${getColor("common.border")};
            }
        `,
    },
});
